import React from "react";

import { Modal } from "react-bootstrap";
import HtmlToReactParser from "html-to-react";

import { getMyPromo, searchPromo } from "../../model/promo";

import { commonErr } from "../common/errors";
import { formatPrice, moment } from "../common/common";

import { LoadingInline } from "../common/loading";

import { PromoCD, IcPromo, IcPromoDisabled, IcInformation } from "../common/svg";

export const AlertPromoBox = ({ show, onHide, onPromoBox }) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-s modal-dialog modal-confirm">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Thông báo</h5>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-confirm-body">
					<p className="font-14">Xe đã áp dụng giá ưu đãi, bạn có chắc chắn sử dụng Mã&nbsp;khuyến&nbsp;mãi?</p>
					<p className="font-12 text-gray">
						Lưu ý: Xe sẽ không áp dụng mã ưu đãi nếu sử dụng đồng thời với Mã&nbsp;khuyến&nbsp;mãi
					</p>
				</div>
				<div className="wrap-btn has-2-btn">
					<a className="btn btn-primary btn--m" onClick={() => onPromoBox()}>
						Áp dụng
					</a>
					<a className="btn btn-link" onClick={() => onHide()}>
						Hủy bỏ
					</a>
				</div>
			</Modal.Body>
		</Modal>
	);
};

const PromoItem = ({ code, togglePromoCodeDetail, onPromoCodeClick }) => {
	let htmlToReactParser = new HtmlToReactParser.Parser();

	const contentDayExpired = (notAvail) => {
		const dayExpired = Math.floor((code.validDateTo - moment().valueOf()) / 86400000);
		let content;
		if (dayExpired > 7 && !notAvail) {
			return null;
		} else {
			if (notAvail) {
				content = "Mã khuyến mãi không khả dụng";
			} else {
				if (dayExpired === 0) {
					content = "Hết hạn hôm nay";
				} else {
					content = `Hết hạn sau ${dayExpired} ngày`;
				}
			}
		}
		return (
			<>
				{code.validDateTo !== 0 && (
					<div className="date warning">
						<div className="wrap-svg">
							<IcInformation />
						</div>
						{content}
					</div>
				)}
			</>
		);
	};

	return (
		<>
			<div className={`add-promotion__item ${code.notAvail ? "disabled" : ""}`}>
				<div className="wrap-svg">{code.notAvail ? <IcPromoDisabled /> : <IcPromo />}</div>
				<div className="promotion-info">
					<p className="name">{code.code}</p>
					{code.discountPercent > 0 ? (
						<p>
							Giảm {code.discountPercent}% (tối đa {formatPrice(code.discountMax)}).{" "}
							<span onClick={() => togglePromoCodeDetail(code)}>{code.isShowDetail ? `Ẩn chi tiết` : "Chi tiết"}</span>
						</p>
					) : (
						<p>
							Giảm {formatPrice(code.discountMax)}.{" "}
							<span onClick={() => togglePromoCodeDetail(code)}>{code.isShowDetail ? "Ẩn chi tiết" : "Chi tiết"}</span>
						</p>
					)}
					{contentDayExpired(code.notAvail)}
				</div>
				<a className="btn btn-primary" disabled={code.notAvail} onClick={() => onPromoCodeClick(code)}>
					Áp dụng
				</a>
			</div>

			{code.isShowDetail && code.desc && (
				<div className="add-promotion__detail">
					<div className="wrap-svg">
						<PromoCD />
					</div>
					<div>
						<h6>{code.code}</h6>
					</div>
					<div className="promotion">
						{code.validDateFrom !== 0 && code.validDateTo !== 0 && (
							<p>
								Áp dụng từ {moment(code.validDateFrom).format("DD/MM/YYYY")} đến{" "}
								{moment(code.validDateTo).format("DD/MM/YYYY")}
							</p>
						)}
						{htmlToReactParser.parse(code.desc)}
					</div>
				</div>
			)}
			{code.isShowDetail && !code.desc && <div>Không có mô tả</div>}
		</>
	);
};

export default class PromoBox extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			searchCode: "",
		};
	}

	componentDidMount() {
		this.setState({
			err: commonErr.LOADING,
		});
		const { stype, carId, startDate, endDate } = this.props;

		getMyPromo(0, 0, 0, stype, carId, startDate, endDate).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					err: resp.data.error,
					myCodes: resp.data.data.codes.sort((a, b) => a.notAvail - b.notAvail), //code available go first
				});
			} else {
				this.setState({
					err: resp.data.error,
					myCodes: null,
				});
			}
		});
	}

	onSearchCodeChange = (event) => {
		clearTimeout(this.timer);
		const searchCode = event.target.value;
		this.setState({
			searchCode: searchCode,
		});
		this.timer = setTimeout(() => this.searchCode(searchCode), 500);
	};

	searchCode = (searchCode) => {
		if (!searchCode || searchCode === "") {
			return;
		}
		this.setState({
			err: commonErr.LOADING,
		});
		const { stype, carId, startDate, endDate } = this.props;
		searchPromo(searchCode, carId, stype, startDate, endDate).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					searchCode: searchCode,
					err: resp.data.error,
					codes: resp.data.data.codes,
				});
			} else {
				this.setState({
					searchCode: searchCode,
					err: resp.data.error,
					codes: null,
				});
			}
		});
	};

	onPromoCodeClick = (code) => {
		this.props.onPromoCodeClick(code);
		this.props.onHide();
	};

	togglePromoCodeDetail = (code) => {
		code.isShowDetail = !code.isShowDetail;
		this.setState({
			codes: this.state.codes,
			myCodes: this.state.myCodes,
		});
	};

	render() {
		var content;
		var htmlToReactParser = new HtmlToReactParser.Parser();
		const { err, myCodes, codes, searchCode } = this.state;

		if (err === commonErr.LOADING) {
			content = <LoadingInline />;
		} else if (!searchCode || searchCode === "") {
			if (!myCodes || myCodes.length === 0) {
				if (err !== commonErr.INNIT) {
					content = <p>Không tìm thấy mã khuyến mãi.</p>;
				}
			} else {
				content = myCodes.map((code, i) => (
					<PromoItem
						key={i}
						code={code}
						togglePromoCodeDetail={this.togglePromoCodeDetail}
						onPromoCodeClick={this.onPromoCodeClick}
					/>
				));
			}
		} else {
			if (!codes || codes.length === 0) {
				if (err !== commonErr.INNIT) {
					content = <p>Không tìm thấy mã khuyến mãi.</p>;
				}
			} else {
				content = codes.map((code, i) => (
					<PromoItem
						key={i}
						code={code}
						togglePromoCodeDetail={this.togglePromoCodeDetail}
						onPromoCodeClick={this.onPromoCodeClick}
					/>
				));
			}
		}

		return (
			<Modal
				show={this.props.show}
				onHide={this.props.onHide}
				dialogClassName="modal-s modal-dialog modal-add-promotion modal-fix">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Mã khuyến mãi</h5>
				</Modal.Header>
				<Modal.Body>
					<div className="add-promotion">
						<div className="custom-input">
							<div className="wrap-input">
								<input type="text" placeholder="Nhập mã khuyến mãi" onChange={this.onSearchCodeChange} />
							</div>
						</div>
						{content}
					</div>
				</Modal.Body>
			</Modal>
		);
	}
}
